import min from "lodash/min";

function scrollTo(options?: ScrollToOptions) {
  const supportsScrollBehavior = "scrollBehavior" in document.documentElement.style;

  if (supportsScrollBehavior) {
    window.scrollTo(options);
  } else {
    window.scrollTo(options?.left || 0, options?.top || 0);
  }
}

function offset(el: Element) {
  const rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

export function scrollToTop(behavior: ScrollBehavior = "smooth") {
  scrollTo({ top: 0, left: 0, behavior });
}

export function scrollToElement(targetElement?: HTMLElement) {
  if (targetElement) {
    const offsetTarget = offset(targetElement);
    scrollTo({ top: offsetTarget.top, left: 0, behavior: "smooth" });
  }
}

export function scrollToFirstError(rootElement?: HTMLElement) {
  // There is delay between error showup
  setTimeout(() => {
    if (rootElement) {
      const invalidElements = rootElement.getElementsByClassName("is-invalid");

      if (invalidElements.length) {
        const topOffsets = Array.from(invalidElements).map(invalidElement => offset(invalidElement).top);
        const minTopOffset = min(topOffsets) || 50;
        scrollTo({ top: minTopOffset - 120, left: 0, behavior: "smooth" });
        return;
      }

      scrollToElement(rootElement);
      return;
    }

    scrollToTop();
  }, 200);
}
